module.exports = __webpack_public_path__ + "media/application/images/svgs/minus-35dcca19c885da45ad05d55f5d3d9aff.svg";